// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Planocontas_RecalcularResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for planocontas/recalcular endpoint
 *
 * Returns the conta ID and newly calculated valor_efetivo
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Planocontas_RecalcularResponseDados {
id: number
valor_efetivo: number
}

export type Planocontas_RecalcularResponse = ApiResponse<Planocontas_RecalcularResponseDados>;

registerResponseContract('Planocontas_RecalcularResponse', {
  id:            { type: 'number',  required: false },
  valor_efetivo: { type: 'number',  required: false },
})
